import { render, staticRenderFns } from "./AppSuggestions.vue?vue&type=template&id=1d65038c&"
import script from "./AppSuggestions.vue?vue&type=script&lang=js&"
export * from "./AppSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports